import { useParams } from 'react-router-dom';


import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import Spinner from '@/components/common/Spinner/Spinner';
import BundleManager from './components/BundleManager';

interface IBillingCadenceProps {
  onClose: () => void;
}

export default function ManageBundlesModal({
  onClose
}: IBillingCadenceProps) {
  const { contractId }: { contractId: UUID } = useParams();
  const { isContractLoading } = useGetContractDetails(contractId);

  
  return (
      <AgModalWindow
        title={'Manage Bundles'}
        isOpen={true}
        onClose={onClose}
        contentStyle={{ minWidth: '700px', maxWidth: '900px' }}
      >
        {isContractLoading &&
          <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
          <Spinner />
        </div>
        }
        {!isContractLoading && 
        <>
          <BundleManager contractId={contractId} onClose={onClose} />
        </>
        }
      </AgModalWindow>
  );
}
